<template>
    <div>
        <div class="p-6 pb-0">
            <BreadCrumbs :navigation="navigation" />
        </div>
        <div class="p-6 pb-0">

            <div class="mb-4 flex items-center gap-3">
                <button
                    type="button"
                    @click="checked = !checked; reload(undefined, undefined, undefined, checked)"
                    :class="checked ? 'bg-blue-600' : 'bg-gray-300'"
                    class="relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                >
                    <span
                        :class="checked ? 'translate-x-6' : 'translate-x-1'"
                        class="inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform"
                    />
                </button>
                <span class="text-sm text-gray-600">{{ checked ? 'Mostra solo contratti con attività' : 'Mostra solo contratti senza attività' }}</span>
            </div>

            <PageServerTable :headers="headers" :items="items" :items-per-page.sync="ipp" :items-per-page-options="ippo"
                :sort-by="sortby" :items-length="count" :reload-fn="reload" v-model.selected="selected"
                :item-value="'Item'" :page="page" show-current-page
                :row-props="({ item }) => item.activities_count > 0 ? { class: 'row-has-activities' } : {}">
                <template #item.Item="{ item }">
                    <span>'{{ item.Item }}'</span>
                </template>
                <template #item.select="{ item }">
                    <Link :href="route('modules.attivita.gestione-contratto', item.SaleOrdId)"
                        class="p93__btn_primary inline-block px-2 py-1 text-xs">
                        {{ $t('at.actions.generate_activities') }}
                    </Link>
                </template>
                <template #item.OrderDate="{ item }"> <span> {{ formatDate(item.OrderDate) }} </span> </template>
                <template #item.ExpectedDeliveryDate="{ item }"> <span> {{ formatDate(item.ExpectedDeliveryDate) }} </span> </template>
                <template #item.activities_count="{ item }"> <span> {{ item.activities_count }} </span> </template>
            </PageServerTable>
        </div>
    </div>
</template>

<script>
import { Link, router } from '@inertiajs/vue3';
import PageServerTable from '@/Components/PageServerTable.vue';
import BreadCrumbs from '@/Components/BreadCrumbs.vue';


export default {
    props: ['errors', 'items', 'count', 'ippo'],
    components: {
        Link,
        PageServerTable,
        BreadCrumbs,
    },
    data() {
        return {
            checked: false,
            selected: [],
            headers: [],
            sortby: [],
            ipp: 10,
            page: 1,
        };
    },
    computed: {
        navigation() {
            return [
                { name: this.$t('ui.dashboard'), href: route('dashboard') },
                { name: this.$t('modules.attivita'), href: route('modules.home', 'attivita') },
                { name: 'Contratti', href: route('modules.attivita.contratti') },
            ];
        },
    },
    methods: {
        reload(sortby = undefined, itemsperpage = undefined, page = undefined, checked = undefined) {
            if (sortby) this.sortby = sortby;
            if (itemsperpage) this.ipp = itemsperpage;
            if (page) this.page = page;
            if (checked !== undefined) this.checked = checked;

            router.post(
                window.location.href,
                { headers: this.headers, sortby: this.sortby, itemsperpage: this.ipp, page: this.page ,checked: this.checked},
                { only: ['items', 'count'] }
            );
        }
        
    },
    mounted() {
        this.headers = this.$attrs.headers;
        this.ipp     = this.$attrs.ipp;
        this.page    = this.$attrs.page;
        this.sortby  = this.$attrs.sortby;
    },
};
</script>

<style>
.row-has-activities td {
    background-color: #dcfce7 !important;
}
</style>
